import type {ApolloClient} from '@apollo/client'
import type {GetServerSidePropsContext} from 'next'
import {initializeApollo} from 'src/api/saleor'
import {isFirstServerCall} from '.'

export const initGQLClient = (
  context: GetServerSidePropsContext,
): null | ApolloClient<unknown> =>
  isFirstServerCall({context}) ? initializeApollo() : null
